import Store from '../store/store'
import Router from '../router';

import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'

export function connectHub(hubName) {
    const connection = new HubConnectionBuilder().withUrl(hubName, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
    }).configureLogging(LogLevel.Information)
    .build(); 

    return connection;
}

//const connection1=connectHub('/contatti-streamer-hub');
//const connection2=connectHub('/clienti-streamer-hub');
//const connection3=connectHub('/pratiche-streamer-hub');
//startConnection(connection1);
//startConnection(connection2);
//startConnection(connection3);


//enumerable per gli snack

export const Snack = {
    success: 0,
    error: 1,
    cancel: 2,
    nothing: 4,
    remote: 5
}

export const callService = async function (service, param, noStaticParam,appendQuey) {
    let serviceStatic = [service];
    let paramList = "";
    if (noStaticParam) {
        paramList = (serviceStatic.concat(param)).join("/");
    }
    else {
        let paramStatic = [Store.state.partition, Store.state.utente.username, Store.state.utente.token];
        paramList = (serviceStatic.concat(paramStatic).concat(param)).join("/");
    }

    if(appendQuey) {
        paramList += appendQuey;
    }

    const start = Date.now();
    const response = await fetch(paramList, 
        {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Store.state.accessToken,
              }
        }
    );
    const end = Date.now();
    let time = end - start;
    console.log("TIME EXECUTION - "+paramList+" : "+time+" ms");

    //errore di login/accesso

    if (response.status >= 400 && response.status <= 499) {
        logout();
        return null;
    }

    //errore applicativo

    if (response.status >= 500) {
        return false;
    };

    const data = await response.json();
    return data;
};

export const callPost = async function (service, paramJson, byPassError) {

    const start = Date.now();

    const response = await fetch(service, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Store.state.accessToken,
          },
        body: JSON.stringify(paramJson)
    });

    const end = Date.now();
    let time = end - start;
    console.log("TIME EXECUTION POST - " + service + " : " + time + " ms");

    //errore di login/accesso

    if (response.status >= 400 && response.status<=499) {
        if (byPassError) {
            return null;
        }
        else {
            logout();
            return;
        }
    };

    //errore applicativo

    if (response.status >= 500) {
        return false;
    };

    const data = await response.json();
    return data;
};

export const callPostMultipart = async function (service, param, byPassError) {

    const start = Date.now();

    const response = await fetch(service, {
        method: 'post',
        body: param
    });

    const end = Date.now();
    let time = end - start;
    console.log("TIME EXECUTION POST MULTIPART - " + service + " : " + time + " ms");    

    //errore di login/accesso

    if (response.status >= 400 && response.status <= 499) {
        if (byPassError) {
            return null;
        }
        else {
            logout();
            return;
        }
    };

    //errore applicativo

    if (response.status >= 500) {
        return false;
    };

    const data = await response.json();
    return data;
};

export const euro = function (importo) {
    if (isNaN(importo)) return "-";
    if (importo == 0) return "0,00  €"; //evita il -0
    return (Number(importo)).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })
};

export const gLocalData = function (stringDate) {
    if (!stringDate) return null;
    var d = new Date(stringDate);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    return [day, month, year].join('/');
};

export const gLocalDateTime = function (stringDate) {
    if (!stringDate) return null;
    var d = new Date(stringDate);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    let hh = d.getHours().toString();
    if (hh.length < 2) hh = '0' + hh;
    let mm = d.getMinutes().toString();
    if (mm.length < 2) mm = '0' + mm;
       
    return [day, month, year].join('/')+ " "+hh+":"+mm;
};

export const gDataCalendar = function (stringDate) {
    if (!stringDate) return null;
    var d = new Date(stringDate);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    return [year, month, day].join('-');
};

export const gControllData = function (d) {
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    return [year, month, day].join('-');
};

export const gCheckData = function (d) {
    var tok = d.split("/");
    var dIso = new Date([tok[2], tok[1], tok[0]].join("-"));
    return !isNaN(dIso);
};

export const gServerData = function (stringDate) {
    //da gg/mm/aaaa a aaaa-mm-gg//

    if (!stringDate) return null;
    var tok = stringDate.split("/");
    return [tok[2], tok[1], tok[0]].join('/');
};

export const gServer2Data = function (stringDate) {
    //da aaaa-mm-gg a aaaa-mm-gg//

    if (!stringDate) return null;
    var tok = stringDate.split("-");
    var tok1 = "01";
    if (tok[2])
    {
        var tk1 = tok[2].split("T");
        tok1 = tk1[0];
    }
    var appo = [tok[0], tok[1], tok1].join('/');
    return appo;
};

export const logout = function () {
    Store.dispatch('logout');
    Store.dispatch('setUtente', null);
    Router.replace({ name: "login" });
};

export const gSynch1 = async function () {
    let param = [];
    let confApp = await callService("api/lplApp", param);
    Store.state.lplApp = confApp.lplApp;
    Store.state.isAlert = confApp.isAlert;
    Store.state.isExpired = confApp.isExpired;
    Store.state.isLocked = confApp.isLocked;
    Store.state.sourceLogo = confApp.sourceLogo;
    Store.state.studioName = confApp.lplApp.denominazione;
    Store.state.spazioWeb = confApp.lplApp.spazioWeb;
    Store.state.listaTipoRecapito = await callService("api/tiporecapito", param);
    Store.state.listaTipoCliente = await callService("api/tipocliente", param);
    Store.state.listaTipoScadenza = await callService("api/tiposcadenza", param);
    Store.state.listaTipoIndirizzario = await callService("api/tipoindirizzario", param);
    //
    Store.state.parametri = await callService("api/configurazione/parametri", param);
    Store.state.spaceInfo = await callService("api/partition/getspace", param); 
};

export const gSynch2 = async function () {
    let param = [];
    Store.state.listaTipoAttivita = await callService("api/tipoattivita", param);
    Store.state.listaOperatore = await callService("api/operatore/listaoperatoricompleta", param);
    Store.state.listaOperatoriProfessionisti = await callService("api/professionista/listaprofessionisticompleta", param);
    Store.state.listaPeriodicitaContabile = await callService("api/periodo/tipoperiodicitaconscont", param);
    Store.state.listaPeriodicitaServizi = await callService("api/periodo/tipoperiodicitaservizi", param);
    Store.state.listaModuliArPdf = await callService("api/antiriciclaggio/listamoduli", param);
};

export const gSynch3 = async function () {
    let param = [];
    Store.state.listaPeriodicitaLavoro = await callService("api/periodo/tipoperiodicitaconslav", param);
    Store.state.listaTipoPagamento = await callService("api/tipopagamento", param);
    Store.state.listaTipoConsulenza = await callService('api/tipoconsulenza', param);
    Store.state.listaTipoRegimeIVA = await callService("api/tiporegimeiva", param);
    Store.state.listaTipoRegimeContabile = await callService("api/tiporegimecontabile", param);
    //tabelle PUBLIC
    Store.state.listaComuni = await callService('api/tabelleistat/listacomuni', param);
    Store.state.listaStati = await callService('api/tabelleistat/listastati', param);
    Store.state.listaTipiAdeguataVerifica = await callService("api/antiriciclaggio/listaTAV", param);
    Store.state.listaTipiDocumentoIndentificativo = await callService("api/antiriciclaggio/listaTDI", param);
    Store.state.listaTipiFileAntiriciclaggio = await callService("api/antiriciclaggio/listaTFA", param);
    Store.state.listaTipiPrestazioneRischioInerente = await callService("api/antiriciclaggio/listaTPRI", param);
    Store.state.listaTVRS = await callService("api/antiriciclaggio/listaTVRS", param);
    Store.state.listaTVRI = await callService("api/antiriciclaggio/listaTVRI", param);
    Store.state.listaTVV = await callService("api/antiriciclaggio/listaTVV", param);
};

export const gSynch4_Old = async function () {
    let param = [];
    Store.state.utenti = await callService('api/utente', param);
    Store.state.utentiClienti = await callService('api/utente/listaUtentiClientiApp', param);
    Store.state.contattiEstesi = await callService('api/cliente/listaContattiEstesa', param);
};

export const gSynch4 = async function () {
    let param = [];
    Store.state.utenti = await callService('api/utente', param);
    Store.state.utentiClienti = await callService('api/utente/listaUtentiClientiApp', param);
    //contatti in streaming
    let nRows=-1;
    let row = 0.0;
    Store.state.loadingContatti.indeterminate = false;
    Store.state.loadingContatti.progress = 0;
    Store.state.loadingContatti.value = true;
    Store.state.contattiEstesi.length=0; //svuoto senza far perdere il riferimento all'array

    const connection1=connectHub('/contatti-streamer-hub');

    let startedPromise = connection1.start()
        .then(function () {
            console.info("SignalR OK");

            connection1.stream("ListaContattiStreaming", Store.state.partition, Store.state.utente.username, Store.state.utente.token)
            .subscribe({
                next: (lista) => {       
                    lista.forEach(contattoEsteso => {
                        row++;        
                        if(nRows==-1) {
                            nRows = contattoEsteso.nRows;
                            console.info("NRows="+nRows);            
                            Store.state.loadingContatti.nRows = nRows;    
                        }
                        Store.state.loadingContatti.progress = (row/nRows)*100;   
                        Store.state.contattiEstesi.push(contattoEsteso);   
                    });                          
                },
                complete: async() => {
                    Store.state.loadingContatti.value = false;
                    Store.state.loadingContatti.indeterminate = true;
                    console.log(connection1.state);
                    await connection1.stop();
                    console.log(connection1.state);
                },
                error: (err) => {
                    
                },
            });
        })
        .catch(err => {
            console.error('"SignalR KO"', err)
            return new Promise((resolve, reject) =>
                setTimeout(() => start().then(resolve).catch(reject), 5000))
        });       
};

export const gSynch5_old = async function () {
    let param = [Store.state.idAnnoContabile];
    Store.state.clientiEstesi = await callService('api/cliente/listaestesa', param);
};

export const gSynch5_stream = async function () {
    let param = [Store.state.idAnnoContabile];
    callServiceStream('api/cliente/listaestesa2',param, Store.state.clientiEstesi,Store.state.loadingClienti);  
    console.log("OK Synch5");
};


export const gSynch5 = async function () {
    let nRows=-1;
    let row = 0.0;
    Store.state.loadingClienti.indeterminate = false;
    Store.state.loadingClienti.progress = 0;
    Store.state.loadingClienti.value = true;
    Store.state.clientiEstesi.length=0; //svuoto senza far perdere il riferimento all'array

    const connection2=connectHub('/clienti-streamer-hub');

    let startedPromise = connection2.start()
        .then(function () {
            console.info("SignalR OK");

            connection2.stream("ListaClientiStreaming", Store.state.partition, Store.state.utente.username, Store.state.utente.token,Store.state.idAnnoContabile)
            .subscribe({
                next: (lista) => {       
                    lista.forEach(clienteEsteso => {
                        row++;        
                        if(nRows==-1) {
                            nRows = clienteEsteso.nRows;
                            console.info("NRows="+nRows);            
                            Store.state.loadingClienti.nRows = nRows;    
                        }
                        Store.state.loadingClienti.progress = (row/nRows)*100;   
                        Store.state.clientiEstesi.push(clienteEsteso);   
                    });                          
                },
                complete: async() => {
                    Store.state.loadingClienti.value = false;
                    Store.state.loadingClienti.indeterminate = true;
                    console.log(connection2.state);
                    await connection2.stop();
                    console.log(connection2.state);
                },
                error: (err) => {
                    
                },
            });
        })
        .catch(err => {
            console.error('"SignalR KO"', err)
            return new Promise((resolve, reject) =>
                setTimeout(() => start().then(resolve).catch(reject), 5000))
        });    
};

export const gSynch6 = async function (isService, isStorico,loading,praticheEstese,idCliente) {
    let nRows=-1;
    let row = 0.0;
    loading.indeterminate = false;
    loading.progress = 0;
    loading.value = true;
    praticheEstese.length=0; //svuoto senza far perdere il riferimento all'array

    const connection3=connectHub('/pratiche-streamer-hub');

    let startedPromise = connection3.start()
        .then(function () {
            console.info("SignalR OK");

            connection3.stream("ListaPraticheStreaming", Store.state.partition, Store.state.utente.username, Store.state.utente.token,isService, isStorico,idCliente)
            .subscribe({
                next: (lista) => {       
                    lista.forEach(praticaEstesa => {
                        row++;        
                        if(nRows==-1) {
                            nRows = praticaEstesa.nRows;
                            console.info("NRows="+nRows);            
                            loading.nRows = nRows;    
                        }
                        loading.progress = (row/nRows)*100;   
                        praticheEstese.push(praticaEstesa);
                        //console.log(praticheEstese.length);
                    });                          
                },
                complete: async () => {
                    loading.value = false;
                    loading.indeterminate = true;
                    console.log(connection3.state);
                    await connection3.stop();
                    console.log(connection3.state);
                },
                error: (err) => {
                    
                },
            });
        })
        .catch(err => {
            console.error('"SignalR KO"', err)
            return new Promise((resolve, reject) =>
                setTimeout(() => start().then(resolve).catch(reject), 5000))
        });

    
};

export const gSynch7 = async function () {
    let nRows=-1;
    let row = 0.0;
    const connection4=connectHub('/knowtable-streamer-hub');

    let startedPromise = connection4.start()
        .then(function () {
            console.info("SignalR OK");

            connection4.stream("KnowTableStreaming", Store.state.partition, Store.state.utente.username, Store.state.utente.token)
            .subscribe({
                next: (lista) => {     
                    console.log("LUNGHEZZA="+lista.length);
                    if(!Store.state.listaPeriodi) Store.state.listaPeriodi=lista;
                    else if(!Store.state.listaDettaglioSettimana) Store.state.listaDettaglioSettimana=lista;
                    else if(!Store.state.listaDettaglioMese) Store.state.listaDettaglioMese=lista;
                    else if(!Store.state.listaServCon) Store.state.listaServCon=lista;
                    else if(!Store.state.listaConti) Store.state.listaConti=lista;
                    else if(!Store.state.listaTagsIni) Store.state.listaTagsIni=lista;                                        
                },
                complete: async () => {                    
                    await connection4.stop();
                },
                error: (err) => {
                    
                },
            });
        })
        .catch(err => {
            console.error('"SignalR KO"', err)
            return new Promise((resolve, reject) =>
                setTimeout(() => start().then(resolve).catch(reject), 5000))
        });

    
};

